import { useQuery } from '@tanstack/react-query';
import { collection, getDocs } from 'firebase/firestore';
import firebaseApp from '../firebase-app';
import { FS_PATH_TEAMS } from '../constants';
export const getTeams = async (): Promise<any[]> => {
  const querySnapshot = await getDocs(collection(firebaseApp.db, FS_PATH_TEAMS));
  const teams: any = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    teams.push({
      // abbrv: doc.id,
      ...data,
    });
  });
  return teams;
};

export function useAllTeams() {
  const res = useQuery({
    queryKey: ['all-teams'],
    queryFn: async () => {
      const res = await getTeams();
      return res;
    },
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  return res;
}
